import { useEffect } from 'react'
import { setCommonModuleValues, getAuthState, getTsgIdFromUrl, cleanupTsgIdFromUrl } from '../common/utils/Sparky'
import type { Location as HistoryLocation } from 'history'

const useSelecetedTsg = (location: Location | HistoryLocation) => {
  useEffect(() => {
    const tsgId = getTsgIdFromUrl(location as Location)
    if (tsgId) {
      const tsg = getAuthState().tsgs.get(tsgId)
      if (tsg) {
        setCommonModuleValues({ tsg })
      }
      cleanupTsgIdFromUrl(location as Location)
    }
  }, [location])
}

export default useSelecetedTsg
